import { VisitMetrics } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { Slide } from '@features/powerpoint';
import { DEFAULT_SLIDE_MASTER } from '../../../slides/slide-master';
import { TextsOptions, texts } from './visit-dimensions/texts';
import { FormSchema } from '@features/executive-report/subdomains/visitation';
import { shapes } from './visit-dimensions/shapes';
import { apiSlugToDimensionName } from '@components/Dashboard/dashboardSlice/responseMappers/dimensionStats';
import { images } from './visit-dimensions/images';
import { visibleSlide } from '@features/executive-report/slides';
import { DimensionRecommendationsSchema } from '@features/executive-report/subdomains/visitation';
import {
  Subdimension,
  SubdimensionsByName,
} from '@features/reports/subdomains/visitation';

const visitDimensionsSlide = (
  options: Omit<TextsOptions, 'subdimensions'> & {
    visible: boolean;
    subdimensions: Subdimension[];
    subdimensionImages: FormSchema['subdimensionImagesByNameAndValue'];
  }
): Slide[] => {
  const subdimensionsWithImages: TextsOptions['subdimensions'] =
    options.subdimensions.map(subdimension => ({
      ...subdimension,
      image:
        options.subdimensionImages[subdimension.name]?.[subdimension.value] ??
        null,
    }));

  return visibleSlide({
    slide: {
      slideMaster: DEFAULT_SLIDE_MASTER,
      texts: texts({ ...options, subdimensions: subdimensionsWithImages }),
      shapes: shapes(subdimensionsWithImages),
      images: images(subdimensionsWithImages),
    },
    visible: options.visible,
  });
};

type VisitDimensionsSlidesOptions = {
  visitMetrics: VisitMetrics;
  subdimensionsByName: SubdimensionsByName;
  recommendations: DimensionRecommendationsSchema;
  includedSlides: FormSchema['includedSlides']['footTraffic'];
  subdimensionImages: FormSchema['subdimensionImagesByNameAndValue'];
};

export const visitDimensionsSlides = (
  options: VisitDimensionsSlidesOptions
): Slide[] => [
  ...(options.subdimensionsByName.aud
    ? [
        ...visitDimensionsSlide({
          activeHeaderTab: 'who',
          recommendation: options.recommendations.who,
          dimensionName: apiSlugToDimensionName.aud,
          subdimensions: options.subdimensionsByName.aud,
          overallMetrics: options.visitMetrics,
          visible: options.includedSlides.who,
          subdimensionImages: options.subdimensionImages,
        }),
      ]
    : []),
  ...(options.subdimensionsByName.creative
    ? [
        ...visitDimensionsSlide({
          activeHeaderTab: 'what',
          recommendation: options.recommendations.what,
          dimensionName: apiSlugToDimensionName.creative,
          subdimensions: options.subdimensionsByName.creative,
          overallMetrics: options.visitMetrics,
          visible: options.includedSlides.what,
          subdimensionImages: options.subdimensionImages,
        }),
      ]
    : []),
  ...(options.subdimensionsByName.channel
    ? [
        ...visitDimensionsSlide({
          activeHeaderTab: 'where',
          recommendation: options.recommendations.where,
          dimensionName: apiSlugToDimensionName.channel,
          subdimensions: options.subdimensionsByName.channel,
          overallMetrics: options.visitMetrics,
          visible: options.includedSlides.where,
          subdimensionImages: options.subdimensionImages,
        }),
      ]
    : []),
];
